<template>
    <div><div >
        <a-button class="top_btn" type="primary"  @click="()=>{visibleForm = true; titleForm='添加分公司'; this.editId=''; }" v-has="'btn_add'"  > 添加分公司 </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" v-has="'btn_listorder'"> 排序</a-button>
        <a-popconfirm
                title="此操作将永久删除, 是否继续?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="start"
                @cancel="()=>{}"
                :disabled="!hasSelected"
        >
            <a-button type="primary" :disabled="!hasSelected" :loading="loading"  v-has="'btn_delete'">
                删除
            </a-button>
        </a-popconfirm>

        <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
    </div>
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="id"
                :pagination="false"
                :scroll="{ x: 1300 }"

        >
        <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改分公司',editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>

          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"  >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <OfficeForm :visible="visibleForm" :title="titleForm" :editId="editId"
                   @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "></OfficeForm>
    </div>
</template>

<script>
    import OfficeForm from "./components/officeForm";
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns =  [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "150px",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "公司名",
            dataIndex: "name",
            ellipsis: true,
            width: "200px",
            key: "name",
        },
        {
            title: "电话",
            key: "phone",
            dataIndex: "phone",
            width: "200px",
        },
        {
            title: "QQ",
            dataIndex: "qq",
            ellipsis: true,
            key: "qq",
            width: "200px",
        },
        {
            title: "微信",
            dataIndex: "wechat",
            ellipsis: true,
            key: "wechat",
            width: "200px",
        },
        {
            title: "地址",
            key: "addr",
            ellipsis: true,
            dataIndex: "addr",
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            fixed: 'right',
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data(){
            return{
                current:1,
                visibleForm: false,
                titleForm: "",
                editId: null,
                data:[],
                columns,
                selectedRowKeys: [],
                loading: true,
                sortLists:[]
            }
        },
        created () {
            this.$store.state.adminleftnavnum="/SiteSettings/BranchOffice"; //设置左侧导航2-2 active
        },
        components:{OfficeForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted(){
            this.getList()
        },
        methods: {
            getList(page) {
                API.branchOffice.GET_LIST(page||1).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
            getchangId(data) {
                this.sortLists=[]
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < data.length; i++) {
                    sortListOrder.id = data[i].id
                    sortListOrder.list_order = data[i].list_order
                    this.sortLists.push(sortListOrder)
                    sortListOrder = {}
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
            },

            listOrder() {
                this.getchangId(this.data)
                orderList(API.branchOffice.LIST_ORDER, this.sortLists).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(row) {
                removeById(API.branchOffice.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            start() {
                this.loading = true;
                removeById(API.branchOffice.DELE, this.selectedRowKeys).then(res => {
                    if (res == true) {
                        this.getList()
                        this.loading = false;
                        this.selectedRowKeys = [];
                    }
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
    }
</script>

<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
